import api from './api';

export const giveawaysService = {
    async getGiveaways(params = {}) {
        const response = await api.get('/giveaways/list/', { params });
        return response.data;
    },

    async getActiveGiveaways() {
        const response = await api.get('/giveaways/list/', {
            params: { status_group: 'active' }
        });
        return response.data;
    },

    async getGiveawayById(id) {
        const response = await api.get(`/giveaways/list/${id}/`);
        return response.data;
    },

    async enterGiveaway(giveawayId, entryData = {}) {
        const response = await api.post('/giveaways/entries/', {
            giveaway: giveawayId,
            ...entryData
        });
        return response.data;
    },

    async getMyEntries(params = {}) {
        const response = await api.get('/giveaways/entries/', { params });
        return response.data;
    },

    async getEntryById(id) {
        const response = await api.get(`/giveaways/entries/${id}/`);
        return response.data;
    },

    async updateEntry(id, data) {
        const response = await api.patch(`/giveaways/entries/${id}/`, data);
        return response.data;
    },

    async deleteEntry(id) {
        await api.delete(`/giveaways/entries/${id}/`);
    },

    async getWinners(params = {}) {
        const response = await api.get('/giveaways/winners/', { params });
        return response.data;
    },

    async getRecentWinners() {
        const response = await api.get('/giveaways/winners/', {
            params: { recent_winners: true }
        });
        return response.data;
    },

    async getGiveawayWinners(giveawayId) {
        const response = await api.get('/giveaways/winners/', {
            params: { giveaway: giveawayId }
        });
        return response.data;
    },

    // Additional helper methods
    async getUpcomingGiveaways() {
        const response = await api.get('/giveaways/list/', {
            params: { status_group: 'upcoming' }
        });
        return response.data;
    },

    async getEndedGiveaways() {
        const response = await api.get('/giveaways/list/', {
            params: { status_group: 'ended' }
        });
        return response.data;
    },

    async searchGiveaways(query) {
        const response = await api.get('/giveaways/list/', {
            params: { search: query }
        });
        return response.data;
    }
}; 